import React, { useState } from 'react'
import DragUpload from "./DragUpload";


const LeadImport = ({authToken}) => {
    const [dragZone, setDragZone] = useState(false);
    const [counter, setCounter] = useState(1);


    const openDragZone = (value) => {
        setDragZone(value)
      }
    const resetCounter = () => {
        setCounter(1);
      }



  return (
    <>
   <div className="text-lg font-[600] mb-5 pt-10 px-10">Lead Import</div>
    <div className="w-full flex my-6 mx-auto">
          <div className="flex relative w-full mx-8">
            <DragUpload authToken={ authToken } resetCounter={resetCounter} dragZone={dragZone} openDragZone={openDragZone} />
          </div>
        </div>
    </>
  )
}

export default LeadImport
